import React from 'react';
import { motion } from 'framer-motion';
import avocadoImg from '../../images/avocado.png';
import lemonImg from '../../images/lemon.png';
import listochekImg from '../../images/listochek.png';
import './floating-fruits.scss';

const FloatingFruits = () => {
  const fruits = [
    {
      id: 1,
      image: avocadoImg,
      alt: 'Avocado',
      size: 'small',
      delay: 0,
      duration: 8,
      x: '10%',
      y: '20%'
    },
    {
      id: 2,
      image: lemonImg,
      alt: 'Lemon',
      size: 'medium',
      delay: 2,
      duration: 12,
      x: '85%',
      y: '15%'
    },
    {
      id: 3,
      image: listochekImg,
      alt: 'Leaf',
      size: 'small',
      delay: 4,
      duration: 10,
      x: '15%',
      y: '70%'
    },
    {
      id: 4,
      image: avocadoImg,
      alt: 'Avocado',
      size: 'tiny',
      delay: 1,
      duration: 15,
      x: '90%',
      y: '80%'
    },
    {
      id: 5,
      image: lemonImg,
      alt: 'Lemon',
      size: 'small',
      delay: 3,
      duration: 9,
      x: '5%',
      y: '45%'
    },
    {
      id: 6,
      image: listochekImg,
      alt: 'Leaf',
      size: 'medium',
      delay: 5,
      duration: 11,
      x: '75%',
      y: '60%'
    },
    {
      id: 7,
      image: avocadoImg,
      alt: 'Avocado',
      size: 'tiny',
      delay: 6,
      duration: 13,
      x: '50%',
      y: '10%'
    },
    {
      id: 8,
      image: lemonImg,
      alt: 'Lemon',
      size: 'small',
      delay: 7,
      duration: 7,
      x: '95%',
      y: '40%'
    }
  ];

  const getSizeClass = (size) => {
    switch (size) {
      case 'tiny': return 'w-8 h-8';
      case 'small': return 'w-12 h-12';
      case 'medium': return 'w-16 h-16';
      default: return 'w-12 h-12';
    }
  };

  return (
    <div className="floating-fruits">
      {fruits.map((fruit) => (
        <motion.div
          key={fruit.id}
          className={`floating-fruit ${getSizeClass(fruit.size)}`}
          style={{
            left: fruit.x,
            top: fruit.y,
            '--fruit-delay': `${fruit.delay}s`,
            '--fruit-duration': `${fruit.duration}s`
          }}
          initial={{ 
            opacity: 0, 
            scale: 0,
            rotate: 0
          }}
          animate={{
            opacity: [0, 0.6, 0.8, 0.6, 0],
            scale: [0, 1, 1.1, 1, 0],
            rotate: [0, 180, 360, 540, 720],
            y: [0, -20, 20, -10, 0],
            x: [0, 10, -10, 5, 0]
          }}
          transition={{
            duration: fruit.duration,
            repeat: Infinity,
            delay: fruit.delay,
            ease: "easeInOut"
          }}
          whileHover={{
            scale: 1.5,
            rotate: 360,
            opacity: 1,
            transition: { duration: 0.5 }
          }}
        >
          <img 
            src={fruit.image} 
            alt={fruit.alt}
            className="fruit-image"
          />
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingFruits;
